import React from 'react';
import classnames from 'classnames';
import makeConstants from 'lib/makeConstants';

import './practice-view-toolbar.scss';

const ToolbarDivider = () => <div className='practice-view-toolbar__divider' />;

const alignTypes = makeConstants('end', 'start');

interface Props {
  align?: (typeof alignTypes)[keyof typeof alignTypes];
  children?: React.ReactNode;
}

export default class PracticeViewToolbar extends React.Component<Props> {
  static Divider = ToolbarDivider;

  render() {
    const {align, children} = this.props;
    return (
      <div className='practice-view-toolbar'>
        <div
          className={classnames('practice-view-toolbar__content max-s:overflow-x-auto', {
            'justify-end': align === alignTypes.end
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}
